// extracted by mini-css-extract-plugin
export default {"ticketList":"TicketList_ticketList__4GuNT","ticketInformation":"TicketList_ticketInformation__nlPbu"};